import React, {
    useEffect, useState, useCallback,
} from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import _ from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import {
    RadioGroup,
    FormControlLabel,
    Radio,
    Checkbox,
    FormHelperText,
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import format from 'date-fns/format';
import FormDialog from '../../../components/Dialog/FormDialog';
import Button from '../../../components/Button/CustomButton';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import CustomTypography from '../../../components/Typography/CustomTypography';
import adminListOrganizerStyle from '../../../assets/jss/pages/adminListOrganizerStyle';
import CleanableInput from '../../../components/Input/CleanableInput';
import SelectorInput from '../../../components/Input/SelectorInput';
import Validation from '../../../common/Validation';
import {
    Trash,
} from '../../../components/Icons/Icon';
import Pricing from '../../../components/Pricing/Pricing';
import DateLimit from '../../../components/DatePicker/DateLimit';
import UploadButton from '../../../components/Button/UploadButton';
import SuccessDialog from '../../../components/Dialog/SuccessDialog';
import SnackBar from '../../../components/Snackbar/Snackbar';
import CustomTable from '../../../components/Table/Table';
import Loader from '../../../components/Loader/Loader';
import { locationOption, optionRegis, ORGANIZER_TYPE } from '../../../common/Constants';
import LiveStreamOrganizer from '../../Home/LiveStreamOrganizer';
import SeminarService from '../../../services/seminar';

const useStyles = makeStyles(adminListOrganizerStyle);
const checkDuplicate = (newRoom, roomTimes) => {
    for (let index = 0; index < roomTimes.length; index += 1) {
        if (
            roomTimes[index].date === newRoom.date
            && roomTimes[index].room === newRoom.room
            && roomTimes[index].stime === newRoom.stime
            && roomTimes[index].etime === newRoom.etime
            && roomTimes[index].roomMoney === newRoom.roomMoney
        ) {
            return false;
        }
    }
    return true;
};

const DialogRegister = ({
    isOpen,
    handleClose,
    eventInfo,
    createOrganizer,
    successCreate,
    getInformationRoom,
    room,
    errors,
    options,
    isLoading,
    clearData,
    fetchJobs,
    jobs,
    fetchCategory,
    category,
    fetchEventZones,
    zones,
    getListOrganizer,
    getOccupations,
    occupations,
    clearOccupations,
}) => {
    const intl = useIntl();
    const classes = useStyles();
    const [params, setParams] = useState({
        checkRule: false,
        organizerType: '0',
        dateSeminar: '',
        register_ads_max: '',
        has_ads: '',
        has_payment: '0',
    });
    const [optionRoom, setOptionRoom] = useState({});
    const [optionRoomMoney, setOptionRoomMoney] = useState({});
    const [optionTime, setOptionTime] = useState({});
    const [roomTime, setRoomTime] = useState([]);
    const { shortName } = useParams();

    const [validateResults, setValidateResults] = useState({});
    const [errorCreate, setErrorCreate] = useState({ isOpen: false, type: 'error', message: '' });
    const [listEventState, setListEventState] = useState([]);
    const [listOptionCompanyFromApi, setListOptionCompanyFromApi] = useState({});
    const [listOptionEmployeeNumberFromApi, setOptionEmployeeNumberFromApi] = useState({});
    const [listOptionOccupationFromApi, setOptionOccupationFromApi] = useState({});
    const [listZoneFromApi, setListZoneFromApi] = useState({});
    const [jobState, setJobState] = useState({});
    const [categoryState, setCategoryState] = useState({});
    const [occupationState, setOccupationState] = useState({});
    const [displayExhibition, setDisplayExhibition] = useState('0');
    const [displaySeminar, setDisplaySeminar] = useState('0');
    const [displayLiveStream, setDisplayLiveStream] = useState('0');
    const [objLiveStream, setObjLiveStream] = useState([]);
    const [availableDates, setAvailableDates] = useState([]);
    const [isOpenDialog, setIsOpenDialog] = useState(false);

    useEffect(() => {
        if (isOpen) {
            fetchJobs(shortName);
            fetchCategory({shortName,});
            fetchEventZones(shortName);
            getOccupations({ shortName });

            try {
                SeminarService.getAvailableDates(shortName)
                    .then((res) => {
                        const arrDate = Object.keys(res);

                        setAvailableDates(arrDate);
                    });
            } catch {
                setAvailableDates([]);
            }
        }
        return () => {
            clearData();
            clearOccupations();
            setParams({
                checkRule: false,
                organizerType: '0',
                dateSeminar: '',
                register_ads_max: '',
                has_ads: '',
                has_payment: '0',
            });
            setDisplayExhibition('0');
            setDisplaySeminar('0');
            setDisplayLiveStream('0');
            setValidateResults({});
        };
    }, [isOpen]);

    // Set list Option Company
    useEffect(() => {
        if (options && options.company_option) {
            let temp = {};
            options.company_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setListOptionCompanyFromApi({ ...listOptionCompanyFromApi, ...temp });
        }
    }, [options]);

    // Set list employee_number
    useEffect(() => {
        if (options && options.employee_number_option) {
            let temp = {};
            options.employee_number_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setOptionEmployeeNumberFromApi({ ...listOptionEmployeeNumberFromApi, ...temp });
        }
    }, [options]);

    // Set list Occupation
    useEffect(() => {
        if (options && options.occupation_option) {
            let temp = {};
            options.occupation_option.forEach((key, i) => {
                temp = { ...temp, [i]: key[i] };
            });
            setOptionOccupationFromApi({ ...listOptionOccupationFromApi, ...temp });
        }
    }, [options]);

    // Set list event zone ***
    useEffect(() => {
        if (zones.length) {
            const listZone = _.reduce(zones, (rs, item) => {
                rs[item.id] = item.name;
                return rs;
            }, { 0: '選択して下さい' });
            setListZoneFromApi(listZone);
        }
    }, [zones]);

    useEffect(() => {
        if (!_.isEmpty(listZoneFromApi)) {
            handleSetParams('zone', Number(Object.keys(listZoneFromApi)[0]));
        }
    }, [listZoneFromApi]);

    useEffect(() => {
        if (params.organizerType !== optionRegis.event && params.dateSeminar) {
            const date = formatDateCallAPI(params.dateSeminar);
            getInformationRoom({ shortName, date });
        }
    }, [params.dateSeminar]);

    useEffect(() => {
        const booth = {};

        if (params.organizerType === optionRegis.seminar) {
            booth.booth = 0;
        }
        if (params.organizerType === optionRegis.event) {
            setRoomTime([]);
        }

        setParams({ ...params, dateSeminar: eventInfo.sdate, ...booth });
    }, [params.organizerType]);

    // Set room from api
    useEffect(() => {
        const temp = {};
        const temp1 = {};
        let temp2 = '';
        Object.keys(room).forEach((key, i) => {
            if (!i) {
                temp2 = key;
            }
            temp[key] = key;
            temp1[key] = `${key} ( ${room[`${key}`].price}円 )`;
        });

        setOptionRoom(temp);
        setOptionRoomMoney(temp1);
        if (temp[temp2]) {
            const timer = room[temp[temp2]];
            const timeRoomOptions = {};
            if (timer.times) {
                timer.times.forEach((key, i) => {
                    timeRoomOptions[i] = `${key.stime}~${key.etime}`;
                });
            }
            setOptionTime(timeRoomOptions);
            setParams({
                ...params,
                timeSeminar: timeRoomOptions[0],
                roomSeminar: temp[temp2],
                roomSeminarMoney: temp1[temp2],
            });
        }
    }, [room]);

    // Set room select when has room
    useEffect(() => {
        if (optionRoom) {
            const temp = Object.keys(optionRoom)[0];
            setParams({ ...params, roomSeminar: optionRoom[temp], roomSeminarMoney: optionRoomMoney[temp] });
        } else {
            setParams({ ...params, roomSeminar: '', roomSeminarMoney: '' });
        }
    }, [optionRoom]);

    // Set time when has room
    useEffect(() => {
        if (params.roomSeminar) {
            const timer = room[params.roomSeminar];
            const temp = {};
            if (timer.times) {
                timer.times.forEach((key, i) => {
                    temp[i] = `${key.stime}~${key.etime}`;
                });
            }
            setOptionTime(temp);
            setParams({ ...params, timeSeminar: temp[0] });
        } else {
            setOptionTime([]);
            setParams({ ...params, timeSeminar: '' });
        }
    }, [params.roomSeminar]);

    useEffect(() => {
        if (errors && errors.errors && errors.errors.code === 'BAD_REQUEST') {
            setValidateResults({ ...errors.errors });
            setErrorCreate({
                ...errorCreate,
                isOpen: true,
                type: 'error',
                message: errors.errors.message
                    ? (errors.errors.message.message || errors.errors.non_field_errors.message) : 'エラーが発生しました入力された情報を確認してください',
            });
        } else {
            setErrorCreate({
                ...errorCreate, isOpen: false,
            });
        }
    }, [errors]);

    useEffect(() => {
        if (successCreate) {
            handleClose(false);
            setIsOpenDialog(true);
        }
    }, [successCreate]);

    const handleCloseDialog = () => {
        clearData();
        setIsOpenDialog(false);
        getListOrganizer(shortName);
    };

    // Set data table when room select
    useEffect(() => {
        if (!_.isEmpty(roomTime)) {
            const tableData = roomTime.map((item, index) => [
                formatDate(item.date),
                `${item.stime}~${item.etime}`,
                item.roomMoney,
                <IconButton
                    onClick={() => removeRoomTime(index)}
                >
                    <Trash />
                </IconButton>,
            ]);
            setListEventState(tableData);
        }
    }, [roomTime]);

    useEffect(() => {
        if (!_.isEmpty(jobs)) {
            setJobState(_.reduce(jobs, (result, value) => ({ ...result, [value]: value }), { '': '' }));
        }
    }, [jobs]);

    useEffect(() => {
        if (!_.isEmpty(category)) {
            setCategoryState(_.reduce(category, (result, value) => ({ ...result, [value]: value }), { '': '' }));
        }
    }, [category]);

     useEffect(() => {
        if (!_.isEmpty(occupations)) {
            setOccupationState(_.reduce(occupations, (result, value) => ({ ...result, [value]: value }), { '': '' }));
        }
    }, [occupations]);

    const addRoomTime = () => {
        const {
            dateSeminar, timeSeminar, roomSeminar, roomSeminarMoney,
        } = params;
        if (dateSeminar && timeSeminar && roomSeminar && roomSeminarMoney) {
            const stateTime = timeSeminar.split('~')[0];
            const endTime = timeSeminar.split('~')[1];
            const newRoom = {
                date: dateSeminar,
                room: roomSeminar,
                stime: stateTime,
                etime: endTime,
                roomMoney: roomSeminarMoney,
            };
            if (checkDuplicate(newRoom, roomTime)) {
                setRoomTime([...roomTime, newRoom]);
            }
        }
    };

    const removeRoomTime = (index) => {
        const roomUpdate = roomTime;
        roomUpdate.splice(index, 1);
        setRoomTime([...roomUpdate]);
    };

    const createDataToCallApi = () => {
        const dataToCallApi = {
            organizer_type: checkOrganizerType(),
            company_full_name: checkUndefined(params.companyFullName),
            company_short_name: checkUndefined(params.companyShortName),
            company_type: checkUndefined(params.companyType),
            companyCategory: checkUndefined(params.companyCategory),
            company_url: checkUndefined(params.companyUrl),
            company_description: checkUndefined(params.companyDescription),
            email: checkUndefined(params.email),
            event: eventInfo.id,
            first_name: checkUndefined(params.firstName),
            last_name: checkUndefined(params.lastName),
            department: checkUndefined(params.department),
            position: checkUndefined(params.position),
            location: checkUndefined(params.location),
            zip_code: checkUndefined(params.zipCode),
            address: checkUndefined(params.address),
            phone_number: checkUndefined(params.phoneNumber),
            fax_number: checkUndefined(params.faxNumber),
            booth: checkBooth(),
            seminar: JSON.stringify(checkSeminar()),
            register_ads_max: params.register_ads_max,
            employee_number: checkUndefined(params.employee_number),
            occupation_name: checkUndefined(params.occupation_name),
            live_stream: checkLiveStream(),
            organizer_live_stream: displayLiveStream,
            role: 2,
            payment_method: +params.has_payment,
        };

        if (params.companyImage) {
            dataToCallApi.company_image = params.companyImage;
        }

        if (params?.zone) {
            dataToCallApi.zone = Number(params.zone);
        }

        if (!_.isEmpty(eventInfo.languages)) {
            dataToCallApi.company_full_name_en = checkUndefined(params.companyFullNameEN);
            // dataToCallApi.company_short_name_en = checkUndefined(params.companyShortNameEN);
            dataToCallApi.company_description_en = checkUndefined(params.companyDescriptionEN);
            dataToCallApi.address_en = checkUndefined(params.addressEN);
        }

        return dataToCallApi;
    };

    const checkUndefined = (values) => (!_.isUndefined(values) ? values.trim() : '');

    const formatDate = (data) => (format(new Date(data), 'yyyy/MM/dd'));

    const formatDateCallAPI = (data) => (format(new Date(data), 'yyyy-MM-dd'));

    const handleSubmit = () => {
        if (validate()) {
            const dataToCallApi = createDataToCallApi();
            createOrganizer(dataToCallApi);
        }
    };

    const checkOrganizerType = () => {
        if (displayExhibition === '1' && displaySeminar === '1') {
            return ORGANIZER_TYPE.EXHIBITION_AND_SEMINAR;
        }
        if (displayExhibition === '1') {
            return ORGANIZER_TYPE.EXHIBITION;
        }
        if (displaySeminar === '1') {
            return ORGANIZER_TYPE.SEMINAR;
        }
        return ORGANIZER_TYPE.DISABLE_ALL;
    };

    const checkBooth = () => {
        let result = 0;
        if (displayExhibition === '1') {
            result = params.booth;
        }
        return result;
    };
    const checkSeminar = () => {
        let result = '';
        if (displaySeminar === '1') {
            result = roomTime;
        }
        return result;
    };

    const checkLiveStream = () => {
        let result = [];
        if (!_.isEmpty(objLiveStream)) {
            result = objLiveStream;
        }
        return JSON.stringify(result);
    };

    const validate = () => {
        const {
            email, firstName, lastName, address, checkRule, department, position, companyFullName,
            companyShortName, companyType, companyUrl, companyDescription,
            location, booth, has_ads, register_ads_max, phoneNumber, faxNumber, zipCode,
            emailConfirm, occupation_name, employee_number, zone, has_payment,
            companyFullNameEN, companyShortNameEN, addressEN, companyDescriptionEN,
        } = params;
        const defaultValidateRules = {
            company_full_name: [
                () => Validation.isNotEmpty(companyFullName),
                () => Validation.validateMaxLength(companyFullName, 60),
            ],
            company_short_name: [
                () => Validation.isNotEmpty(companyShortName),
                () => Validation.validateMaxLength(companyShortName, 1000),
            ],
            company_type: [
                () => Validation.isNotEmpty(companyType),
                () => Validation.validateMaxLength(companyType, 255),
            ],
            company_url: [
                () => Validation.validateMaxLength(companyUrl, 500),
                () => Validation.isValidUrl(companyUrl),
            ],
            company_description: [
                () => Validation.validateMaxLength(companyDescription, 1000),
                () => Validation.isNotEmpty(companyDescription),
            ],
            email: [
                () => Validation.isNotEmpty(email),
                () => Validation.validateEmail(email),
                () => Validation.validateMaxLength(email, 255),
            ],
            emailConfirm: [
                () => Validation.validateSame(email, emailConfirm),
            ],
            first_name: [
                () => Validation.isNotEmpty(firstName),
                () => Validation.validateMaxLength(firstName, 255),
            ],
            last_name: [
                () => Validation.isNotEmpty(lastName),
                () => Validation.validateMaxLength(lastName, 255),
            ],
            department: [() => Validation.validateMaxLength(department, 255)],
            position: [() => Validation.validateMaxLength(position, 255)],
            location: [() => Validation.validateMaxLength(location, 255)],
            zip_code: [() => Validation.isNotEmpty(zipCode),
                () => Validation.validateMaxLength(zipCode, 255)],
            address: [() => Validation.isNotEmpty(address),
                () => Validation.validateMaxLength(address, 1000)],
            phone_number: [
                () => Validation.isNotEmpty(phoneNumber),
                () => Validation.validateMaxLength(phoneNumber, 255),
                () => Validation.validatePhoneNumber(phoneNumber && phoneNumber.trim()),
            ],
            fax_number: [() => Validation.validateMaxLength(faxNumber, 255)],
            booth: [displayExhibition === '1' ? (() => Validation.isPositiveNumbers(booth)) : () => { }],
            checkRule: [() => Validation.isCheck(checkRule)],
            seminar: [displaySeminar === '1' ? (() => Validation.validateArr(roomTime)) : () => { }],
            has_ads: [eventInfo.display_ads && eventInfo.register_ads ? () => Validation.isNotEmpty(has_ads) : () => { }],
            register_ads_max: [has_ads > 0 ? () => Validation.limitValue(register_ads_max, 0, eventInfo.register_ads_max) : () => { }],
            employee_number: [() => Validation.isNotEmpty(listOptionEmployeeNumberFromApi[employee_number]),
                () => Validation.validateMaxLength(employee_number, 255)],
            occupation_name: [() => Validation.isNotEmpty(occupation_name),
                () => Validation.validateMaxLength(occupation_name, 255)],
            live_stream: [displayLiveStream === '1' ? (() => Validation.validateArr(objLiveStream)) : () => { }],
            has_payment: [() => Validation.isNumberNotZero(+params.has_payment)],
        };

        if (displayExhibition === '0' && displaySeminar === '0' && displayLiveStream === '0') {
            defaultValidateRules.hasNoApplications = [() => Validation.isNoApplications()];
        }

        if (!_.isEmpty(eventInfo.languages)) {
            defaultValidateRules.company_full_name_en = [
                () => Validation.isNotEmpty(companyFullNameEN),
                () => Validation.validateLatin(companyFullNameEN),
                () => Validation.validateMaxLength(companyFullNameEN, 60),
            ];
            // defaultValidateRules.company_short_name_en = [
            //     () => Validation.isNotEmpty(companyShortNameEN),
            //     () => Validation.validateLatin(companyShortNameEN),
            //     () => Validation.validateMaxLength(companyShortNameEN, 1000),
            // ];
            defaultValidateRules.company_description_en = [
                () => Validation.validateMaxLength(companyDescriptionEN, 1000),
                () => Validation.validateLatin(companyDescriptionEN),
                () => Validation.isNotEmpty(companyDescriptionEN),
            ];
            defaultValidateRules.address_en = [
                () => Validation.isNotEmpty(addressEN),
                () => Validation.validateMaxLength(addressEN, 1000),
                () => Validation.validateLatin(addressEN),
            ];
        }

        const validateRules = !eventInfo.has_zone ? defaultValidateRules : {
            ...defaultValidateRules,
            zone: [() => Validation.validateZone(zone)],
        };

        const validateResult = Validation.validateAllRules(validateRules);

        if (Object.keys(validateResult).length > 0) {
            setValidateResults({ ...validateResult });
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResults({});
        return true;
    };

    const handleSetParams = useCallback((field, valueChange) => {
        setParams((prevParams) => ({ ...prevParams, [field]: valueChange }));
    }, []);

    const handleObjLiveStream = (liveStream) => {
        setObjLiveStream(liveStream);
        setParams({ ...params, live_stream: liveStream });
    };

    const handleUploadImage = (file) => {
        handleSetParams('companyImage', file);
    };
    const handleChangeAds = (event) => {
        handleSetParams('has_ads', event.target.value);
        handleSetParams('register_ads_max', '');
    };

    const handleInputPostalCode = (valueInput) => {
        handleSetParams('zipCode', valueInput);
        valueInput = valueInput.trim();
        const code = valueInput.substr(0, 3);
        if (code && code.length === 3 && valueInput.length === 7) {
            const pathPostal = process.env.REACT_APP_POSTAL_URL || '';
            fetch(`${pathPostal}/postal/${code}.json`)
            .then((res) => res.json())
            .then((data) => {
                const d = data.find((it) => it[valueInput]);
                handleSetParams('address', d[valueInput][0]);
            }).catch(() => {
                // TODO
            });
        } else {
            handleSetParams('address', '');
        }
    };

    const handleChangeDisplayExhibition = (e) => {
        if (e.target.value === '0') setParams({ ...params, booth: objLiveStream });
        setDisplayExhibition(e.target.value);
    };

    const handleChangeDisplaySeminar = (e) => {
        if (e.target.value === '0') setRoomTime([]);
        setDisplaySeminar(e.target.value);
    };

    const handleChangeDisplayLiveStream = (e) => {
        if (e.target.value === '1') {
            setParams({ ...params, live_stream: objLiveStream });
        } else {
            if (params.live_stream) delete params.live_stream;
            setObjLiveStream([]);
            setParams({ ...params });
        }
        setDisplayLiveStream(e.target.value);
    };

    const disableDate = (date) => {
        const formattedDate = format(new Date(date), 'yyyy-MM-dd');

        return !availableDates.includes(formattedDate);
    };

    return (
        <>
            <FormDialog
                isOpen={isOpen}
                handleClose={handleClose}
            >
                <GridContainer>
                    <GridItem>
                        <GridContainer>
                            <GridItem>
                                <CustomTypography bold variant="h4" color="info" align="center" className={classes.eventName}>
                                    {eventInfo.name}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.eventInfo}>
                            <GridItem xs={12} md={4}>
                                <CustomTypography variant="subtitle1" bold>
                                    開催期間
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={8}>
                                <CustomTypography variant="subtitle1" color="info" bold>
                                    {eventInfo.sdate && formatDate(eventInfo.sdate)}
                                    {' '}
                                    ~
                                    {' '}
                                    {eventInfo.edate && formatDate(eventInfo.edate)}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.eventInfo}>
                            <GridItem xs={12} md={4}>
                                <CustomTypography variant="subtitle1" bold>
                                    開催時間
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} sm={8} md={8}>
                                <CustomTypography variant="subtitle1" color="info" bold>
                                    {eventInfo.open_time}
                                    {' '}
                                    ~
                                    {' '}
                                    {eventInfo.close_time}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.margin2vh}>
                            <GridItem xs={12} md={4}>
                                <CustomTypography variant="subtitle1" bold>
                                    開催場所
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={8} md={8} className={classes.textLeft}>
                                <CustomTypography variant="subtitle1">
                                    {eventInfo.address}
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>

                        {eventInfo.has_exhibition && (
                            <GridContainer className={classes.margin2vh}>
                                <GridItem xs={12} md={4}>
                                    <CustomTypography variant="subtitle1" bold required>
                                        展示会への開催
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} sm={8} md={8}>
                                    <RadioGroup
                                        name="exhibition"
                                        value={displayExhibition}
                                        onChange={handleChangeDisplayExhibition}
                                        row
                                    >
                                        <FormControlLabel
                                            value="1"
                                            control={<Radio color="primary" />}
                                            label={<CustomTypography>する</CustomTypography>}
                                        />

                                        <FormControlLabel
                                            value="0"
                                            control={<Radio color="primary" />}
                                            label={<CustomTypography>しない</CustomTypography>}
                                            className={classes.label}
                                        />
                                    </RadioGroup>
                                </GridItem>
                            </GridContainer>
                        )}

                        {eventInfo.has_seminar && (
                            <GridContainer className={classes.margin2vh}>
                                <GridItem xs={12} md={4}>
                                    <CustomTypography variant="subtitle1" bold required>
                                        セミナーの開催
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} sm={8} md={8}>
                                    <RadioGroup
                                        name="seminar"
                                        value={displaySeminar}
                                        onChange={handleChangeDisplaySeminar}
                                        row
                                    >
                                        <FormControlLabel
                                            value="1"
                                            control={<Radio color="primary" />}
                                            label={<CustomTypography>する</CustomTypography>}
                                        />

                                        <FormControlLabel
                                            value="0"
                                            control={<Radio color="primary" />}
                                            label={<CustomTypography>しない</CustomTypography>}
                                            className={classes.label}
                                        />
                                    </RadioGroup>
                                </GridItem>
                            </GridContainer>
                        )}

                        {eventInfo.has_live_stream && (
                            <GridContainer className={classes.margin2vh}>
                                <GridItem xs={12} md={4}>
                                    <CustomTypography variant="subtitle1" bold required>
                                        ライブ配信の開催
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} sm={8} md={8}>
                                    <RadioGroup
                                        name="live_stream"
                                        value={displayLiveStream}
                                        onChange={handleChangeDisplayLiveStream}
                                        row
                                    >
                                        <FormControlLabel
                                            value="1"
                                            control={<Radio color="primary" />}
                                            label={<CustomTypography>する</CustomTypography>}
                                        />

                                        <FormControlLabel
                                            value="0"
                                            control={<Radio color="primary" />}
                                            label={<CustomTypography>しない</CustomTypography>}
                                            className={classes.label}
                                        />
                                    </RadioGroup>
                                </GridItem>
                            </GridContainer>
                        )}

                        {/* Show Text Error When User choose no Application */}
                        <GridContainer className={classes.margin2vh}>
                            <GridItem xs={12} md={4} />
                            <GridItem xs={12} sm={8} md={8}>
                                <FormHelperText error className="MuiFormHelperText-contained">
                                    {validateResults.hasNoApplications
                                        ? intl.formatMessage({ id: validateResults.hasNoApplications.message }) : ''}
                                </FormHelperText>
                            </GridItem>
                        </GridContainer>

                        {eventInfo.display_ads && eventInfo.register_ads && (
                            <GridContainer className={classes.margin2vh}>
                                <GridItem xs={4} md={4}>
                                    <CustomTypography variant="subtitle1" bold required>
                                        広告
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={8} md={8}>
                                    <RadioGroup
                                        aria-label="has_ads"
                                        name="has_ads"
                                        value={params.has_ads}
                                        onChange={(e) => handleChangeAds(e)}
                                        row
                                        // className={classes.paddingLeft15}
                                    >
                                        <FormControlLabel
                                            value="1"
                                            control={<Radio color="primary" />}
                                            label={<CustomTypography>する</CustomTypography>}
                                        />

                                        <FormControlLabel
                                            value="0"
                                            control={<Radio color="primary" />}
                                            label={<CustomTypography>しない</CustomTypography>}
                                            className={classes.label}
                                        />

                                    </RadioGroup>
                                    <FormHelperText error className={`MuiFormHelperText-contained ${classes.margin28}`}>
                                        {validateResults.has_ads && validateResults.has_ads.result
                                            ? intl.formatMessage({ id: validateResults.has_ads.message }) : ''}
                                    </FormHelperText>
                                    <div style={{ display: 'flex' }}>
                                        <CustomTypography variant="subtitle1">
                                            広告搭載申込み件数
                                            <input
                                                value={params.register_ads_max}
                                                onChange={(e) => handleSetParams('register_ads_max', e.target.value)}
                                                type="number"
                                                style={{
                                                    margin: '5px',
                                                    width: '50px',
                                                }}
                                                disabled={!(params.has_ads > 0)}
                                                min={0}
                                            />
                                            件
                                        </CustomTypography>
                                    </div>
                                    <FormHelperText error className={`MuiFormHelperText-contained ${classes.margin28}`}>
                                        {validateResults.register_ads_max && validateResults.register_ads_max.result
                                            ? intl.formatMessage({ id: validateResults.register_ads_max.message }, { minValue: 0, maxValue: eventInfo.register_ads_max }) : ''}
                                    </FormHelperText>

                                    <CustomTypography variant="subtitle1">
                                        1．広告料金
                                        {' '}
                                        {eventInfo.price_ads}
                                        円/1件
                                        <br />
                                        2．広告搭載は「展示サイトのTOP画面の下部」 「出展者一覧の下部」
                                        <br />
                                        「喫茶提示ルームの下部」 と「展示会出口サイト」の4ヶ所に表示
                                        <br />
                                        3．広告募集（1社当り限定）件数
                                        {' '}
                                        {eventInfo.register_ads_max}
                                        件
                                    </CustomTypography>
                                </GridItem>
                            </GridContainer>
                        )}
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem className={classes.formInputInformation} xs={12} md={12}>
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={12} className={classes.textCenter}>
                                <CustomTypography
                                    variant="h5"
                                    color="info"
                                    bold
                                    className={classes.padding15}
                                >
                                    ※企業基本情報
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography required bold>
                                    出展企業名
                                </CustomTypography>
                                <CustomTypography bold>
                                    {!_.isEmpty(eventInfo.languages) ? '（和文）' : '（和文・英文）'}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={12}>
                                        <CleanableInput
                                            onChange={(valueInput) => handleSetParams('companyFullName', valueInput)}
                                            error={!!validateResults.company_full_name}
                                            helperText={validateResults.company_full_name
                                                ? intl.formatMessage(
                                                    { id: validateResults.company_full_name.message },
                                                    { maxLength: 60 },
                                                ) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>

                        {!_.isEmpty(eventInfo.languages) && (
                            <GridContainer className={classes.spacing}>
                                <GridItem xs={12} md={3}>
                                    <CustomTypography required bold>
                                        出展企業名
                                    </CustomTypography>
                                    <CustomTypography bold>
                                        （英文）
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={7}>
                                    <GridContainer>
                                        <GridItem xs={12} md={12}>
                                            <CleanableInput
                                                onChange={(valueInput) => handleSetParams('companyFullNameEN', valueInput)}
                                                error={!!validateResults.company_full_name_en}
                                                helperText={validateResults.company_full_name_en
                                                    ? intl.formatMessage(
                                                        { id: validateResults.company_full_name_en.message },
                                                        { maxLength: 60 },
                                                    ) : ''}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                        )}

                        <GridContainer className={classes.spacing}>
                            {!_.isEmpty(eventInfo.languages) ? (
                                <GridItem xs={12} md={3}>
                                    <CustomTypography required bold>
                                        社名（カナ）
                                    </CustomTypography>
                                </GridItem>
                            ) : (
                                <GridItem xs={12} md={3}>
                                    <CustomTypography required bold>
                                        社名
                                    </CustomTypography>
                                    <CustomTypography bold>
                                        （カナ・英字）
                                    </CustomTypography>
                                </GridItem>
                            )}
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={12}>
                                        <CleanableInput
                                            onChange={(valueInput) => handleSetParams('companyShortName', valueInput)}
                                            error={!!validateResults.company_short_name}
                                            helperText={validateResults.company_short_name
                                                ? intl.formatMessage(
                                                    { id: validateResults.company_short_name.message },
                                                    { maxLength: 1000 },
                                                ) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>


                        /* ★★ */ 
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography bold>
                                出展エリア
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={8}>
                                        <SelectorInput
                                            valueSelected=""
                                            optionList={categoryState}
                                            onChange={(valueInput) => handleSetParams('companyCategory', valueInput)}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>


                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography required bold>
                                    業種
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={8}>
                                        <SelectorInput
                                            error={!!validateResults.company_type}
                                            helperText={validateResults.company_type
                                                ? intl.formatMessage(
                                                    { id: validateResults.company_type.message },
                                                    { maxLength: 255 },
                                                ) : ''}
                                            valueSelected=""
                                            optionList={jobState}
                                            onChange={(valueInput) => handleSetParams('companyType', valueInput)}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography required bold>
                                    職種
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={8}>
                                        <SelectorInput
                                            error={!!validateResults.occupation_name}
                                            helperText={validateResults.occupation_name
                                                ? intl.formatMessage(
                                                    { id: validateResults.occupation_name.message },
                                                    { maxLength: 255 },
                                                ) : ''}
                                            valueSelected=""
                                            optionList={occupationState}
                                            onChange={(valueInput) => handleSetParams('occupation_name', valueInput)}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography required bold>
                                    従業員数
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={8}>
                                        <SelectorInput
                                            error={!!validateResults.employee_number}
                                            helperText={validateResults.employee_number
                                                ? intl.formatMessage(
                                                    { id: validateResults.employee_number.message },
                                                    { maxLength: 255 },
                                                ) : ''}
                                            valueSelected="0"
                                            optionList={listOptionEmployeeNumberFromApi}
                                            onChange={(valueInput) => handleSetParams('employee_number', valueInput)}
                                        />

                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.titleScreen}>
                            <GridItem xs={12} md={12} className={classes.textCenter}>
                                <CustomTypography
                                    variant="h5"
                                    color="info"
                                    bold
                                    className={classes.padding15}
                                >
                                    ※連絡担当者
                                </CustomTypography>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography bold>
                                    部署
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={12}>
                                        <CleanableInput
                                            onChange={(valueInput) => handleSetParams('department', valueInput)}
                                            error={!!validateResults.department}
                                            helperText={validateResults.department
                                                ? intl.formatMessage(
                                                    { id: validateResults.department.message },
                                                    { maxLength: 255 },
                                                ) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography bold>
                                    役職
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={12}>
                                        <CleanableInput
                                            onChange={(valueInput) => handleSetParams('position', valueInput)}
                                            error={!!validateResults.position}
                                            helperText={validateResults.position
                                                ? intl.formatMessage(
                                                    { id: validateResults.position.message },
                                                    { maxLength: 255 },
                                                ) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography required bold>
                                    メールアドレス
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={12}>
                                        <CleanableInput
                                            onChange={(valueInput) => handleSetParams('email', valueInput)}
                                            error={!!validateResults.email}
                                            helperText={validateResults.email
                                                ? intl.formatMessage({ id: validateResults.email.message }, { maxLength: 255 }) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem
                                        xs={12}
                                        md={12}
                                    >
                                        <CustomTypography className={classes.padding15}>
                                            もう一度入力してください
                                        </CustomTypography>
                                        <CleanableInput
                                            onChange={(valueInput) => handleSetParams('emailConfirm', valueInput)}
                                            error={!!validateResults.emailConfirm}
                                            helperText={validateResults.emailConfirm
                                                ? intl.formatMessage({ id: validateResults.emailConfirm.message }) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography required bold>
                                    氏名
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={6} md={6}>
                                        <CustomTypography bold>姓</CustomTypography>
                                        <CleanableInput
                                            defaultValue={params.firstName}
                                            onChange={(valueInput) => handleSetParams('firstName', valueInput)}
                                            error={!!validateResults.first_name}
                                            helperText={validateResults.first_name
                                                ? intl.formatMessage(
                                                    { id: validateResults.first_name.message },
                                                    { maxLength: 255 },
                                                ) : ''}
                                        />
                                    </GridItem>
                                    <GridItem xs={6} md={6}>
                                        <CustomTypography bold>名</CustomTypography>
                                        <CleanableInput
                                            defaultValue={params.lastName}
                                            onChange={(valueInput) => handleSetParams('lastName', valueInput)}
                                            error={!!validateResults.last_name}
                                            helperText={validateResults.last_name
                                                ? intl.formatMessage(
                                                    { id: validateResults.last_name.message },
                                                    { maxLength: 255 },
                                                ) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography bold>
                                    国・地域
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={8}>
                                        <SelectorInput
                                            valueSelected="0"
                                            optionList={locationOption.ja}
                                            onChange={(valueInput) => handleSetParams('location', valueInput)}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography required bold>
                                    郵便番号
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <CleanableInput
                                            onChange={(valueInput) => handleInputPostalCode(valueInput)}
                                            error={!!validateResults.zip_code}
                                            helperText={validateResults.zip_code
                                                ? intl.formatMessage(
                                                    { id: validateResults.zip_code.message },
                                                    { maxLength: 255 },
                                                ) : ''}
                                        />
                                    </GridItem>
                                    <GridItem>
                                        <CustomTypography>
                                            記入例：225-0001 → 2250001 と入力
                                        </CustomTypography>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography required bold>
                                    {!_.isEmpty(eventInfo.languages) ? '住所（和文）' : '住所'}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={12}>
                                        <CleanableInput
                                            defaultValue={params.address}
                                            onChange={(valueInput) => handleSetParams('address', valueInput)}
                                            error={!!validateResults.address}
                                            helperText={validateResults.address
                                                ? intl.formatMessage(
                                                    { id: validateResults.address.message },
                                                    { maxLength: 1000 },
                                                ) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>

                        {!_.isEmpty(eventInfo.languages) && (
                            <GridContainer className={classes.spacing}>
                                <GridItem xs={12} md={3}>
                                    <CustomTypography required bold>
                                        住所（英字）
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={7}>
                                    <GridContainer>
                                        <GridItem xs={12} md={12}>
                                            <CleanableInput
                                                onChange={(valueInput) => handleSetParams('addressEN', valueInput)}
                                                error={!!validateResults.address_en}
                                                helperText={validateResults.address_en
                                                    ? intl.formatMessage(
                                                        { id: validateResults.address_en.message },
                                                        { maxLength: 1000 },
                                                    ) : ''}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                        )}

                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography required bold>
                                    電話番号
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={6}>
                                        <CleanableInput
                                            onChange={(valueInput) => handleSetParams('phoneNumber', valueInput)}
                                            error={!!validateResults.phone_number}
                                            helperText={validateResults.phone_number
                                                ? intl.formatMessage(
                                                    { id: validateResults.phone_number.message },
                                                    { maxLength: 255 },
                                                ) : ''}
                                        />
                                    </GridItem>
                                    <GridItem>
                                        <CustomTypography>
                                            記入例：045-912-2112 → 0459122112 と入力
                                        </CustomTypography>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography bold>
                                    FAX 番号
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={6}>
                                        <CleanableInput
                                            onChange={(valueInput) => handleSetParams('faxNumber', valueInput)}
                                            error={!!validateResults.fax_number}
                                            helperText={validateResults.fax_number
                                                ? intl.formatMessage(
                                                    { id: validateResults.fax_number.message },
                                                    { maxLength: 255 },
                                                ) : ''}
                                        />
                                    </GridItem>
                                    <GridItem>
                                        <CustomTypography>
                                            記入例：045-912-2181 → 0459122181 と入力
                                        </CustomTypography>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography bold>
                                    URL
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={12}>
                                        <CleanableInput
                                            onChange={(valueInput) => handleSetParams('companyUrl', valueInput)}
                                            error={!!validateResults.company_url}
                                            helperText={validateResults.company_url
                                                ? intl.formatMessage(
                                                    { id: validateResults.company_url.message },
                                                    { maxLength: 500 },
                                                ) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography bold>
                                    ガイド画像
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem>
                                        <UploadButton text="ガイド画像" type="image" onChange={(file) => handleUploadImage(file)} isHasClear />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography required bold>
                                    ガイド情報
                                </CustomTypography>
                                {!_.isEmpty(eventInfo.languages) && (
                                    <CustomTypography bold>
                                        （和文）
                                    </CustomTypography>
                                )}
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={12}>
                                        <CleanableInput
                                            isMultiline
                                            onChange={(valueInput) => handleSetParams('companyDescription', valueInput)}
                                            error={!!validateResults.company_description}
                                            helperText={validateResults.company_description
                                                ? intl.formatMessage(
                                                    { id: validateResults.company_description.message },
                                                    { maxLength: 1000 },
                                                ) : ''}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>

                        {!_.isEmpty(eventInfo.languages) && (
                            <GridContainer className={classes.spacing}>
                                <GridItem xs={12} md={3}>
                                    <CustomTypography required bold>
                                        ガイド情報
                                    </CustomTypography>
                                    <CustomTypography bold>
                                        （英字）
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={7}>
                                    <GridContainer>
                                        <GridItem xs={12} md={12}>
                                            <CleanableInput
                                                isMultiline
                                                onChange={(valueInput) => handleSetParams('companyDescriptionEN', valueInput)}
                                                error={!!validateResults.company_description_en}
                                                helperText={validateResults.company_description_en
                                                    ? intl.formatMessage(
                                                        { id: validateResults.company_description_en.message },
                                                        { maxLength: 1000 },
                                                    ) : ''}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                        )}

                        {zones.length > 0 && (
                            <GridContainer className={classes.spacing}>
                                <GridItem xs={12} md={3}>
                                    <CustomTypography required bold>
                                        {intl.formatMessage({ id: 'zone' })}
                                    </CustomTypography>
                                </GridItem>
                                <GridItem xs={12} md={7}>
                                    <GridContainer>
                                        <GridItem xs={12} md={12}>
                                            <SelectorInput
                                                error={!!validateResults.zone}
                                                helperText={validateResults.zone
                                                    ? intl.formatMessage(
                                                        { id: validateResults.zone.message },
                                                    ) : ''}
                                                valueSelected="0"
                                                optionList={listZoneFromApi}
                                                onChange={(valueInput) => handleSetParams('zone', valueInput)}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                        )}
                        <GridContainer className={classes.spacing} style={{ alignItems: 'center' }}>
                            <GridItem xs={12} md={3}>
                                <CustomTypography required bold>
                                    支払い方法
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={7}>
                                <GridContainer>
                                    <GridItem xs={12} md={12}>
                                        <RadioGroup
                                            name="has_payment"
                                            value={params.has_payment}
                                            onChange={(e) => handleSetParams('has_payment', e.target.value)}
                                            row
                                        >
                                            <FormControlLabel
                                                value="1"
                                                control={<Radio color="primary" />}
                                                label={<CustomTypography>クレジット</CustomTypography>}
                                            />
                                            <FormControlLabel
                                                value="2"
                                                control={<Radio color="primary" />}
                                                label={<CustomTypography>銀行口座</CustomTypography>}
                                                className={classes.label}
                                            />
                                        </RadioGroup>
                                    </GridItem>
                                </GridContainer>
                                <FormHelperText error className={`MuiFormHelperText-contained ${classes.margin28}`}>
                                    {validateResults.has_payment && validateResults.has_payment.result
                                        ? 'お支払い方法をお選びください。' : ''}
                                </FormHelperText>
                            </GridItem>
                        </GridContainer>

                        {displayExhibition === '1' && (
                            <>
                                {' '}
                                <GridContainer className={classes.spacing}>
                                    <GridItem xs={12} md={3}>
                                        <CustomTypography required bold>
                                            ブース
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} md={7}>
                                        <CustomTypography>
                                            出展希望ブースは下部の〇にチェックを入れてください。
                                        </CustomTypography>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer justify="center">
                                    <GridItem xs={12} md={10}>
                                        <Pricing tiers={eventInfo.setting_booth} handleOption={(valueInput) => handleSetParams('booth', valueInput)}> </Pricing>
                                        <FormHelperText error className={`MuiFormHelperText-contained ${classes.margin28}`}>
                                            {validateResults.booth && validateResults.booth.result
                                                ? intl.formatMessage({ id: validateResults.booth.message }) : ''}
                                        </FormHelperText>
                                    </GridItem>
                                </GridContainer>
                            </>
                        )}
                        {displaySeminar === '1'
                            && (
                                <>
                                    <GridContainer className={classes.spacing}>
                                        <GridItem xs={12} md={3}>
                                            <CustomTypography required bold>
                                                セミナー
                                            </CustomTypography>
                                        </GridItem>
                                        <GridItem xs={12} md={7}>
                                            <CustomTypography>
                                                セミナー開催日、会議室、時間を選択してください。
                                            </CustomTypography>
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer justify="center">
                                        <GridItem xs={12} md={10}>
                                            <fieldset className={classes.booth} style={{ minWidth: 'auto' }}>
                                                <legend>
                                                    <CustomTypography variant="h5" color="primary" bold>セミナー情報</CustomTypography>
                                                </legend>
                                                <GridContainer>
                                                    <GridItem xs={12} md={12}>
                                                        <GridContainer className={classes.padding15}>
                                                            <GridItem xs={12} md={3}>
                                                                <CustomTypography>
                                                                    開催日
                                                                </CustomTypography>
                                                            </GridItem>
                                                            <GridItem xs={12} md={5}>
                                                                <DateLimit
                                                                    sDate={eventInfo.sdate}
                                                                    eDate={eventInfo.edate}
                                                                    defaultValue={eventInfo.sdate}
                                                                    format="yyyy/MM/dd"
                                                                    onChange={(valueInput) => handleSetParams('dateSeminar', format(new Date(valueInput), 'yyyy-MM-dd'))}
                                                                    shouldDisableDate={disableDate}
                                                                />
                                                            </GridItem>
                                                        </GridContainer>
                                                        <GridContainer className={classes.padding15}>
                                                            <GridItem xs={12} md={3}>
                                                                <CustomTypography>
                                                                    会議室
                                                                </CustomTypography>
                                                            </GridItem>
                                                            <GridItem xs={12} md={5}>
                                                                <SelectorInput
                                                                    valueSelected={params.roomSeminar}
                                                                    optionList={optionRoomMoney}
                                                                    onChange={(valueInput) => {
                                                                        handleSetParams('roomSeminar', optionRoom[valueInput]);
                                                                        handleSetParams('roomSeminarMoney', optionRoomMoney[valueInput]);
                                                                    }}
                                                                />
                                                            </GridItem>
                                                        </GridContainer>
                                                        <GridContainer className={classes.padding15}>
                                                            <GridItem xs={12} md={3}>
                                                                <CustomTypography>
                                                                    時間帯
                                                                </CustomTypography>
                                                            </GridItem>
                                                            <GridItem xs={12} md={5}>
                                                                <SelectorInput
                                                                    valueSelected={params.timeSeminar}
                                                                    optionList={optionTime}
                                                                    onChange={(valueInput) => handleSetParams('timeSeminar', optionTime[valueInput])}
                                                                />
                                                            </GridItem>
                                                        </GridContainer>

                                                        <Box
                                                            display="flex"
                                                            flexDirection="column"
                                                            justify="flex-end"
                                                            alignItems="flex-end"
                                                        >
                                                            <Button color="info" gradient size="md" onClick={addRoomTime}>
                                                                登録
                                                            </Button>
                                                        </Box>
                                                        {roomTime.length > 0 && (
                                                            <CustomTable
                                                                tableHead={['月日', '時間', '会議室', 'アクション']}
                                                                tableHeadWidth={['25%', '25%', '40%', '10%']}
                                                                tableData={listEventState}
                                                                className={classes.maxHeightTable}
                                                            />
                                                        )}
                                                    </GridItem>
                                                    <FormHelperText error className={`MuiFormHelperText-contained ${classes.margin28}`}>
                                                        {validateResults.seminar && validateResults.seminar.result
                                                            ? intl.formatMessage({ id: validateResults.seminar.message }) : ''}
                                                    </FormHelperText>

                                                </GridContainer>
                                            </fieldset>
                                        </GridItem>
                                    </GridContainer>
                                </>
                            )}
                        {
                            displayLiveStream === '1' && (
                                <LiveStreamOrganizer
                                    handleObjLiveStream={(liveStream) => handleObjLiveStream(liveStream)}
                                    startDate={eventInfo.sdate}
                                    endDate={eventInfo.edate}
                                    errorText={validateResults.live_stream && validateResults.live_stream.result
                                        ? intl.formatMessage({ id: validateResults.live_stream.message }) : ''}
                                    isAdmin
                                    isLanguage={!_.isEmpty(eventInfo.languages)}
                                />
                            )
                        }

                        <GridContainer className={classes.spacing}>
                            <GridItem xs={12} md={3} />
                            <GridItem xs={12} md={7}>
                                <CustomTypography className={classes.paddingLeft15} bold>
                                    <a href="https://www.jmbxpand.com/jmb/about_XPAND/termsOfSservice/for_Exhibitor.html" target="blank">
                                        利用規約
                                    </a>
                                </CustomTypography>
                                <FormControlLabel
                                    control={(
                                        <Checkbox
                                            checked={params.checkRule}
                                            color="primary"
                                        />
                                    )}
                                    label={<CustomTypography>同意します</CustomTypography>}
                                    onChange={(e) => handleSetParams('checkRule', e.target.checked)}
                                    className={classes.paddingLeft15}
                                />
                                <FormHelperText error className={`MuiFormHelperText-contained ${classes.margin28}`}>
                                    {validateResults.checkRule && validateResults.checkRule.result
                                        ? intl.formatMessage({ id: validateResults.checkRule.message }) : ''}
                                </FormHelperText>
                            </GridItem>
                        </GridContainer>
                        <GridContainer
                            direction="row"
                            justify="center"
                            alignItems="center"
                        >
                            <Button
                                color="info"
                                gradient
                                onClick={handleSubmit}
                                round
                                className={classes.buttonBig}
                            >
                                送信する
                            </Button>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            </FormDialog>
            <SuccessDialog
                title="登録完了"
                open={isOpenDialog}
                contents="アカウントが作成できました。"
                handleClose={handleCloseDialog}
            />
            <SnackBar
                open={errorCreate.isOpen}
                onClose={() => setErrorCreate(false)}
                message={errorCreate.message}
                severity={errorCreate.type}
                autoHideDuration={3000}
            />
            <Loader isLoading={isLoading} />
        </>
    );
};

DialogRegister.defaultProps = {
    handleClose: () => {},
    isOpen: false,
    eventInfo: {},
    getInformationRoom: () => { },
    createOrganizer: () => { },
    errors: {},
    room: {},
    options: {},
    successCreate: false,
    fetchJobs: () => {},
    jobs: [],
    fetchCategory: () => {},
    category: [],
    getListOrganizer: () => {},
    getOccupations: () => {},
    occupations: {},
    clearOccupations: {},
};

DialogRegister.propTypes = {
    handleClose: PropTypes.func,
    isOpen: PropTypes.bool,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    getInformationRoom: PropTypes.func,
    createOrganizer: PropTypes.func,
    room: PropTypes.oneOfType([() => null, PropTypes.object]),
    errors: PropTypes.oneOfType([() => null, PropTypes.object]),
    options: PropTypes.oneOfType([() => null, PropTypes.object]),
    successCreate: PropTypes.bool,
    isLoading: PropTypes.bool.isRequired,
    clearData: PropTypes.func.isRequired,
    fetchJobs: PropTypes.func,
    jobs: PropTypes.oneOfType([() => null, PropTypes.array]),
    fetchCategory: PropTypes.func,
    category: PropTypes.oneOfType([() => null, PropTypes.array]),
    fetchEventZones: PropTypes.func.isRequired,
    zones: PropTypes.oneOfType([null, PropTypes.array]).isRequired,
    getListOrganizer: PropTypes.func,
    getOccupations: PropTypes.func,
    occupations: PropTypes.oneOfType([() => null, PropTypes.object]),
    clearOccupations: PropTypes.func,
};

export default DialogRegister;
